const BASE_DEV_URL = 'https://dev'
const DOMAIN = 'dexfreight.io'
const LOCAL_IP = 'http://localhost:8080'

export const environment = {
  production: false,
  prov: false,
  local: false,
  hmr: false,
  multicontainersUrl: `https://dev-multicontainers.dexcarga.com`,

  hostIp: `${BASE_DEV_URL}-api.${DOMAIN}`,
  scheduleUrl: `${BASE_DEV_URL}-schedule.${DOMAIN}`,
  // srcUrl: `${LOCAL_IP}`,
  srcUrl: `${BASE_DEV_URL}-src.${DOMAIN}`,

  prefixUrl: BASE_DEV_URL,
  domain: DOMAIN,
  inspector: true,
  googleApiKey: 'AIzaSyBaZGjVoTcGOWt6h7b-QAqASEriJ4cMrao',
  // Telemetría de uso (`TelemetryService`). `traceHeaders` manda x-dex-trace/x-dex-session en cada llamada: solo donde el CORS de la entrada está comprobado.
  telemetry: { enabled: true, traceHeaders: false },
}
